export const usePermissions = {
    setPermissions(permissions) {
        localStorage.setItem('permissions', JSON.stringify(permissions));
    },

    async getPermissions() {

        const permissions = localStorage.getItem('permissions');
        return permissions ? JSON.parse(permissions) : [];

    },

    async hasPermission(permissionSlug) {
        const permissions = await this.getPermissions();
        return permissions.indexOf(permissionSlug) > -1;
    },

    clearPermissions() {
        localStorage.removeItem('permissions');
    }
}; 